import { render, staticRenderFns } from "./allmusiccategory.vue?vue&type=template&id=7952080c&"
import script from "./allmusiccategory.vue?vue&type=script&lang=js&"
export * from "./allmusiccategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports